import React from 'react'

function ContactUs() {
    return (
        <div>This is Contact Us</div>
    )
}

export default ContactUs